var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-upload",
        {
          staticClass: "pay-popup-img",
          attrs: {
            "show-file-list": false,
            action: _vm.uploadUrl,
            headers: _vm.headers,
            "on-success": _vm.handleAvatarSuccess,
            "before-upload": _vm.beforeAvatarUpload,
          },
        },
        [
          _c("div", { staticClass: "upload-inner__box" }, [
            _c("div", { staticStyle: { "line-height": "0px" } }, [
              _vm.value
                ? _c("img", {
                    staticClass: "avatar",
                    staticStyle: {
                      "max-width": "120px",
                      "max-height": "120px",
                    },
                    attrs: {
                      src: _vm.imageAccessDomain + _vm.value,
                      alt: "上传图片",
                    },
                  })
                : _c("i", { staticClass: "el-icon-plus pay-popup-img-icon" }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "el-upload__tip pay-popup-img-tip" }, [
              _vm._v(
                "(只能上传jpg/png文件，且不超过" +
                  _vm._s(_vm.limit) +
                  _vm._s(_vm.limitUnit) +
                  ")"
              ),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.value
        ? _c(
            "div",
            [
              _c(
                "el-button",
                { attrs: { type: "text" }, on: { click: _vm.showPic } },
                [_vm._v("查看图片")]
              ),
              _vm._v(" "),
              _c("el-image", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: false,
                    expression: "false",
                  },
                ],
                ref: "showBigPic",
                attrs: {
                  src: _vm.imageAccessDomain + _vm.value,
                  "preview-src-list": [_vm.imageAccessDomain + _vm.value],
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }